export default {
	Array: true,
	Boolean: true,
	console: true,
	Date: true,
	decodeURI: true,
	decodeURIComponent: true,
	encodeURI: true,
	encodeURIComponent: true,
	Infinity: true,
	Intl: true,
	isFinite: true,
	isNaN: true,
	JSON: true,
	Map: true,
	Math: true,
	NaN: true,
	Number: true,
	Object: true,
	parseFloat: true,
	parseInt: true,
	RegExp: true,
	Set: true,
	String: true,
	undefined: true,
};
